<template>
  <div class="app-container">
    <Container
      :title="t('Acceptance.acceptanceReceiptDetail')"
      :hasLine="true"
    >
      <template #main>
        <el-form
          label-width="680px"
          ref="cFormRef"
          label-position="left"
          style="margin-left:15%; font-size: 14px;"
        >
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.draftNo')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.draftNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.draftRange')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.draftRange }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('company.companyCode')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.companyCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.requestObject')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.requestObject }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.receiveBankName')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.receiveBankName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.requestDate')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.requestDate }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.splitFlag')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatSplitFlag(detailData.splitFlag) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.banendFlag')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatBanendFlag(detailData.banendFlag) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.draftType')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatDraftType(detailData.draftType) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.requestEntrustPay')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatRequestEntrustPay(detailData.requestEntrustPay) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.issueDate')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.issueDate }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.bankName')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.bankName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.dueDate')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.dueDate }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.draftAmt')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatThousands(detailData.draftAmt) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('Acceptance.status')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ status }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row style="margin-bottom: 5px">
          <el-col
            :span="12"
          >
            <span class="header-title">流转记录</span>
          </el-col>
        </el-row>
        <SimpleTable
          ref="tableRef"
          :listLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :hadSelect="false"
          :had-operate="false"
        />
      </template>
    </Container>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { formatDate, formatThousands } from '@/utils'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { getAcceptanceBillTransfers, getProcessedDetails } from '@/apis/accepted-bill/acceptanceReceipt'
import {
  formatBanendFlag, formatBehaveType, formatDraftType, formatRequestEntrustPay, formatSignupMark, formatSplitFlag
} from '@/utils/acceptanceBillFormatUtil'
import Container from '@/components/form/container/Container.vue'
import { ElMessage } from 'element-plus'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import {
  AcceptanceBillDetailModel, AcceptanceBillTransfersParamModel,
  ReceiptAcceptedBillTransferRecordModel
} from '@/model/accepted-bill/acceptedBillModel'

export default defineComponent({
  name: 'AcceptanceHistoryDetail',
  methods: { formatThousands },
  components: {
    SimpleTable,
    Container
  },
  setup() {
    const { t } = useI18n()
    const tableRef = ref()
    const id = useRoute().params.id.toString()
    const statusMap = {
      0: t('acceptanceStatus.pendingConfirmation'),
      1: t('acceptanceStatus.underReview'),
      2: t('acceptanceStatus.pendingAction'),
      3: t('acceptanceStatus.operated'),
      98: t('acceptanceStatus.received'),
      99: t('acceptanceStatus.rejected')
    }
    const detailTableStruct = [
      { prop: 'behaveNo', label: t('Acceptance.behaveNo') },
      { prop: 'behaveType', label: t('Acceptance.behaveType'), formatter: (row: ReceiptAcceptedBillTransferRecordModel) => formatBehaveType(row.behaveType) },
      { prop: 'behaveDate', label: t('Acceptance.behaveDate'), formatter: (row: ReceiptAcceptedBillTransferRecordModel) => formatDate(row.behaveDate, 'yyyy-MM-dd') },
      { prop: 'requestObject', label: t('Acceptance.requestObject') },
      { prop: 'requestBankName', label: t('Acceptance.requestBankName') },
      { prop: 'responseObject', label: t('Acceptance.responseObject') },
      { prop: 'responseBankName', label: t('Acceptance.responseBankName') },
      { prop: 'banendFlag', label: t('Acceptance.banendFlagTrue'), formatter: (row: ReceiptAcceptedBillTransferRecordModel) => formatBanendFlag(row.banendFlag) },
      { prop: 'signupMark', label: t('Acceptance.signupMark'), formatter: (row: ReceiptAcceptedBillTransferRecordModel) => formatSignupMark(row.signupMark) }
    ]
    const dataMap = reactive({
      tableData: Array<ReceiptAcceptedBillTransferRecordModel>(),
      columnStruct: detailTableStruct,
      listLoading: true,
      detailData: {} as AcceptanceBillDetailModel | null,
      status: null as string | null,
      async getData() {
        dataMap.listLoading = true

        let acceptanceId
        try {
          acceptanceId = Number(id)
        } catch (error) {
          ElMessage({
            message: 'id 格式错误;' + id,
            type: 'error',
            duration: 2000
          })
          return
        }
        const data = await getProcessedDetails(acceptanceId)
        if (data && data.data) {
          dataMap.detailData = data.data
          dataMap.tableData = data.data.transferRecords
          dataMap.status = statusMap[data.data.status]
          if (!dataMap.tableData || dataMap.tableData.length === 0) {
            const params: AcceptanceBillTransfersParamModel = {
              companyCode: dataMap.detailData.companyCode,
              companyBankId: dataMap.detailData.companyBank,
              status: dataMap.detailData.status,
              draftNo: dataMap.detailData.draftNo,
              draftRange: dataMap.detailData.draftRange,
              draftType: dataMap.detailData.draftType
            }
            const transferData = await getAcceptanceBillTransfers(params)
            if (transferData && transferData.data) {
              dataMap.tableData = transferData.data
            } else {
              ElMessage({
                message: transferData?.msg,
                type: 'error',
                duration: 2000
              })
            }
          }
        } else {
          dataMap.detailData = null
          ElMessage({
            message: data?.msg,
            type: 'error',
            duration: 2000
          })
        }

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    onMounted(() => {
      dataMap.getData()
    })
    return {
      t,
      tableRef,
      formatBanendFlag,
      formatSplitFlag,
      formatRequestEntrustPay,
      formatDraftType,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>
.header-title {
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}
</style>
